import { createSelector } from 'reselect';

const selectCache = (state: any) => state.dashboardCache;

export const selectRangeText = createSelector(
  selectCache,
  (cache: any) => cache.rangeText
);

export const selectAdminRangeText = createSelector(
  selectCache,
  (cache: any) => cache.uiSelectionState.adminRangeText
);

export const selectShowShape = createSelector(
  selectCache,
  (cache: any) => cache.showShape
);

export const selectShowPoint = createSelector(
  selectCache,
  (cache: any) => cache.showPoint
);

export const selectShowGrid = createSelector(
  selectCache,
  (cache: any) => cache.showGrid
);
